import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IGABTransactionFilterFormMeta {
    terminalNumber: FormInputMeta;
    transactionCode: FormInputMeta;
    status: FormInputMeta;
    treatmentStatus: FormInputMeta;
    transactionRef: FormInputMeta;
    cardNumber: FormInputMeta;
    dateFrom: FormInputMeta;
    dateTo: FormInputMeta;

    schema: any;
}

const gabTransactionFilterFormMeta = {} as IGABTransactionFilterFormMeta;

gabTransactionFilterFormMeta.terminalNumber = {
    name: "terminalNumber",
    type: "select",
    label: "Num. Terminal",
    placeholder: "",
    validation: yup.string()
};

gabTransactionFilterFormMeta.transactionCode = {
    name: "transactionCode",
    type: "select",
    label: "Code Transaction",
    placeholder: "",
    validation: yup.string()
};

gabTransactionFilterFormMeta.status = {
    name: "status",
    type: "text",
    label: "Statut",
    placeholder: "",
    validation: yup.string()
};

gabTransactionFilterFormMeta.treatmentStatus = {
    name: "treatmentStatus",
    type: "select",
    label: "Statut Traitement",
    placeholder: "",
    validation: yup.string()
};

gabTransactionFilterFormMeta.transactionRef = {
    name: "transactionRef",
    type: "text",
    label: "Ref. Transaction",
    placeholder: "",
    validation: yup.string()
};

gabTransactionFilterFormMeta.cardNumber = {
    name: "cardNumber",
    type: "text",
    label: "Num. Carte",
    placeholder: "",
    validation: yup.string()
};

gabTransactionFilterFormMeta.dateFrom = {
    name: "dateFrom",
    type: "date",
    label: "De",
    placeholder: "",
    validation: yup.date()
};

gabTransactionFilterFormMeta.dateTo = {
    name: "dateTo",
    type: "date",
    label: "A",
    placeholder: "",
    validation: yup.date()
};


gabTransactionFilterFormMeta.schema = yup.object().shape(getValidationSchema(gabTransactionFilterFormMeta));

export default gabTransactionFilterFormMeta;